"use client";

import * as React from "react";
import { Award, Sparkles, Star, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "S. Jenkins",
  role: "PRESIDENT AND CEO",
  room: "Orbital Systems",
  category: "leadership",
  years: "20+ years",
  cert1: "\n",
  cert2: "Orbital Dynamics",
  bio: "Dr. Vance leads the TiaLinx, Inc. engineering division, overseeing the development of next-generation sensing arrays. With over two decades of experience in orbital intelligence, she is dedicated to pushing the boundaries of what is possible in deep space monitoring.",
  image: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/fm-1.png?v=sgbolr2dchs",
  srcset: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/fm-1.png?v=siqxdr1kak-wvc-srcset",
  sizes: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/fm-1.png?v=lg0g6fq6k5-wvc-sizes",
  featured: true,
  badgeColor: "bg-[#507697] text-white"
}, {
  id: 2,
  name: "Maj Gen (Retired)\nClint Crosier\xA0\xA0",
  role: "STRATEGIC ADVISOR",
  room: "SDA EXPERTA",
  category: "leadership",
  years: "18 years",
  cert1: "\n",
  cert2: "Strategic Command",
  bio: "Marcus manages the daily mission cadence at TiaLinx, Inc., ensuring that our orbital intelligence backbones remain operational and precise. He believes that technical rigor and clear communication are the pillars of mission success.",
  image: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/1774582031278.webp?v=j1sf6yvxtxb",
  srcset: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/1774582031278.png?v=k4exad9byxi-wvc-srcset",
  sizes: "https://bil.eci.mybluehost.me/wp-content/uploads/2026/06/1774582031278.png?v=h81qy64m9oa-wvc-sizes",
  featured: true,
  badgeColor: "bg-[#507697] text-white"
}, {
  id: 3,
  name: "Dr. A. Thorne",
  role: "Lead Sensor Engineer",
  room: "Hardware Lab",
  category: "engineering",
  years: "12 years",
  cert1: "Signal Processing",
  cert2: "Quantum Sensing",
  bio: "With over 12 years of experience, Dr. Thorne designs the high-fidelity sensing arrays that define our orbital intelligence. His work ensures that TiaLinx, Inc. remains at the forefront of technical precision.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/eng_aris_thorne.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/eng_aris_thorne.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/eng_aris_thorne.png-wvc-sizes",
  featured: false,
  badgeColor: "bg-[#45596F] text-white"
}, {
  id: 4,
  name: "Sarah Jenkins",
  role: "Data Analyst",
  room: "Intelligence Hub",
  category: "intelligence",
  years: "9 years",
  cert1: "Predictive Modeling",
  cert2: "Deep Space Data",
  bio: "Sarah specializes in interpreting complex telemetry streams. She provides the actionable insights that allow our clients to make informed decisions in high-stakes environments.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/intel_sarah_jenkins.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/intel_sarah_jenkins.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718072/img/intel_sarah_jenkins.webp-wvc-sizes",
  featured: false,
  badgeColor: "bg-[#45596F] text-white"
}];
const filters = [{
  value: "all",
  label: "All Personnel"
}, {
  value: "leadership",
  label: "Leadership"
}, {
  value: "engineering",
  label: "Engineering"
}, {
  value: "intelligence",
  label: "Intelligence"
}];
export default function TechnicalLeadership() {
  const [activeFilter, setActiveFilter] = React.useState("all");
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const filteredMembers = activeFilter === "all" ? teamMembers : teamMembers.filter(m => m.category === activeFilter);
  return <section data-section-id="207" id="technical-leadership" className="relative bg-[#080F1A] py-20 md:py-28 lg:py-32 overflow-hidden"></section>;
}